import { render, staticRenderFns } from "./RecaptchaDisclosure.vue?vue&type=template&id=7f34f34e&"
import script from "./RecaptchaDisclosure.vue?vue&type=script&lang=ts&"
export * from "./RecaptchaDisclosure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports